if (!customElements.get('variants-dropdown')) {
  class VariantsDropdown extends HTMLElement {
    /**
     * Properties.
     */
    selectors = {
      collection: 'variants-collection',
      toggleBtn: '[data-variants-dropdown-toggle]',
      filterCheckbox: '[data-variants-filter-checkbox]',
      filterApplyBtn: '[data-variants-apply-color-filters]',
      clearFilters: '[data-variants-clear-filters]',
      head: '[data-variants-dropdown-head]',
    };

    /**
     * constructor.
     */
    constructor() {
      super();
    }

    /**
     * connectedCallback.
     */
    connectedCallback() {
      this.collection = this.closest(this.selectors.collection);
      this.head = this.querySelector(this.selectors.head);
      this.filterCheckboxes = this.querySelectorAll(
        this.selectors.filterCheckbox,
      );
      this.filterApplyBtn = this.querySelector(this.selectors.filterApplyBtn);
      this.clearFilters = this.querySelector(this.selectors.clearFilters);

      this.attachListeners();
    }

    /**
     * attachListeners.
     */
    attachListeners() {
      this.head.addEventListener('click', this.handleToggle.bind(this));
      this.filterCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener(
          'change',
          this.handleFilterCheckboxChange.bind(this),
        );
      });
      this.clearFilters.addEventListener(
        'change',
        this.handleClearCheckboxChange.bind(this),
      );
      this.filterApplyBtn.addEventListener(
        'click',
        this.handleApplyBtnClick.bind(this),
      );
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.closeDropdown.call(this);
        if (e.key === 'Enter') this.handleApplyBtnClick.call(this);
      });

      document.addEventListener('click', this.handleDocumentClick.bind(this));
    }

    /**
     * handleClearFilters.
     * @param {Event} e
     */
    handleClearFilters(e) {
      if (e) {
        e.preventDefault();
      }

      const event = new CustomEvent('reset-filters');

      this.filterCheckboxes.forEach((checkbox) => (checkbox.checked = false));
      this.collection.dispatchEvent(event);
      // this.clearFiltersBtn.setAttribute('active', true);
      this.closeDropdown();
    }

    /**
     * toggleApplyBtn.
     */
    toggleApplyBtn() {
      const allCheckboxes = [...this.filterCheckboxes, this.clearFilters];
      this.classList.toggle('has-active-filters', allCheckboxes.length > 0);
    }

    /**
     * handleClearCheckboxChange.
     * @param {Event} e
     */
    handleClearCheckboxChange(e) {
      if (!e.currentTarget === this.clearFilters) return;

      this.toggleApplyBtn();

      if (this.clearFilters.checked) {
        this.filterCheckboxes.forEach((checkbox) => {
          if (checkbox !== this.clearFilters) checkbox.checked = false;
        });
      }
    }

    /**
     * handleFilterCheckboxChange.
     * @param {Event} e
     */
    handleFilterCheckboxChange(e) {
      this.toggleApplyBtn();

      const checked = Array.from(this.filterCheckboxes).filter(
        (checkbox) => checkbox.checked,
      );

      if (checked.length && this.clearFilters.checked) {
        this.clearFilters.checked = false;
      }
    }

    /**
     * handleApplyBtnClick.
     * @param {Event} e
     */
    handleApplyBtnClick(e) {
      const event = this.clearFilters.checked
        ? new CustomEvent('reset-filters')
        : new CustomEvent('filter-colors');

      this.collection.dispatchEvent(event);
      this.closeDropdown();
    }

    /**
     * handleToggle.
     * @param {Event} e
     */
    handleToggle(e) {
      if (e.target === this.filterApplyBtn) return;

      this.toggleAttribute('open');
    }

    /**
     * closeDropdown.
     */
    closeDropdown() {
      this.removeAttribute('open');
    }

    /**
     * handleDocumentClick.
     * @param {Event} e
     */
    handleDocumentClick(e) {
      if (this.contains(e.target)) return;

      this.removeAttribute('open');
    }
  }

  customElements.define('variants-dropdown', VariantsDropdown);
}
